import React, { useState,useEffect } from "react";
import ReactStars from "react-rating-stars-component";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import ProductCard from "../components/ProductCard";
import ReactImageZoom from "react-image-zoom";
import Color from "../components/Color";
import { TbGitCompare } from "react-icons/tb";
import { AiOutlineHeart } from "react-icons/ai";
import { Link,useNavigate } from "react-router-dom";
import watch from "../images/watch.jpg";
import Container from "../components/Container";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector} from "react-redux";
import { getAProduct, rateAProduct} from "../features/products/productSlice";
import { Markup } from "interweave";
import {toast} from "react-toastify"
import {addProdToCart} from "../features/user/userSlice"
import { getUserCart } from "../features/user/userSlice";


const SingleProduct = () => {
  const [color,setColor] = useState(null);
  const [quantity,setquantity] = useState(1);
  const [alreadyAdded,setAlreadyAdded] = useState(false);
  const location = useLocation();
  const getProductId = location.pathname.split("/")[2];
  const productState = useSelector((state)=> state?.product?.singleproduct);
  const productStates = useSelector((state)=> state?.product?.products);
  const cartState = useSelector((state)=> state?.auth?.userCart);
  const navigate = useNavigate();
const dispatch = useDispatch();
  useEffect(()=>{
   dispatch(getAProduct(getProductId));
   //dispatch(getUserCart());
  },[])

  useEffect(() => {
    if (cartState) { // Check if cartState is not undefined
      for (let index = 0; index < cartState.length; index++) {
        if (getProductId === cartState[index]?.productId?._id) {
          setAlreadyAdded(true);
        }
      }
    }
  }, [cartState]);

  const uploadCart = ()=>{
    if(color==null)
    {
      toast.error("Please Select Color")
      return false;
    }
    else{
      dispatch(addProdToCart({productId:productState?._id,quantity,color,price:productState?.price}));
      dispatch(getUserCart());
    }
  }

  const props = {
    width: 594,
    height: 600,
    zoomWidth: 600,

    //img: "https://images.pexels.com/photos/125779/pexels-photo-125779.jpeg?cs=srgb&dl=pexels-fernando-arcos-125779.jpg&fm=jpg",
    img : productState?.images[0]?.url ? productState?.images[0]?.url : "https://images.pexels.com/photos/125779/pexels-photo-125779.jpeg?cs=srgb&dl=pexels-fernando-arcos-125779.jpg&fm=jpg",

  };

  const [orderedProduct, setOrderedProduct] = useState(true);
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const copyToClipboard = (text) => {
    var textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    setIsLinkCopied(true);
  };

  const [comment,setComment] = useState(null);
  
  const [star,setStar] = useState(null);
  
    const addRatingToProduct = ()=>{

      if(star === null)
      {
        toast.error("Please give rating");
        return false;
      }

      else if(comment === null)
      {
        toast.error("Please add comment");
        return false;
      }

      else{
        dispatch(rateAProduct({star:star,comment:comment,prodId:getProductId}));

        setTimeout(()=>{
          dispatch(getAProduct());
        },300)
       
      }
      return false;
      
    }   

  return (
    <>
      <Meta title={"Product Name"} />
      <BreadCrumb title={productState?.title} />
      <Container class1="main-product-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-6">
            <div className="main-product-image">
              <div>
                <ReactImageZoom {...props} />
              </div>
            </div>
            <div className="other-product-images d-flex flex-wrap gap-15">
              <div>
                <img
                  src={productState?.images[0]?.url}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div>
                <img
                  src={productState?.images[0]?.url}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div>
                <img
                  src={productState?.images[0]?.url}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div>
                <img
                  src={productState?.images[0]?.url}
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="main-product-details">
              <div className="border-bottom">
                <h3 className="title">
                  {productState?.title}
                </h3>
              </div>
              <div className="border-bottom py-3">
                <p className="price">₹{productState?.price}</p>
                <div className="d-flex align-items-center gap-10">
                  <ReactStars
                    count={5}
                    size={24}
                    value={productState?.totalrating?.toString()}
                    edit={false}
                    activeColor="#ffd700"
                  />
                  <p className="mb-0 t-review">{productState?.ratings?.length} Reviews</p>
                </div>
                <a className="review-btn" href="#review">
                  Write a Review
                </a>
              </div>
              <div className=" py-3">
                {/* <div className="d-flex gap-10 align-items-center my-2">
                  <h3 className="product-heading">Type :</h3>
                  <p className="product-data">Watch</p>
                </div> */}
                <div className="d-flex gap-10 align-items-center my-2">
                  <h3 className="product-heading">Brand :</h3>
                  <p className="product-data">{productState?.brand}</p>
                </div>
                <div className="d-flex gap-10 align-items-center my-2">
                  <h3 className="product-heading">Category :</h3>
                  <p className="product-data">{productState?.category}</p>
                </div>
                <div className="d-flex gap-10 align-items-center my-2">
                  <h3 className="product-heading">Tags :</h3>
                  <p className="product-data">{productState?.tags}</p>
                </div>
                <div className="d-flex gap-10 align-items-center my-2">
                  <h3 className="product-heading">Availablity :</h3>
                  <p className="product-data">In Stock</p>
                </div>
                <div className="d-flex gap-10 flex-column mt-2 mb-3">
                  <h3 className="product-heading">Size :</h3>
                  <div className="d-flex flex-wrap gap-15">
                    <span className="badge border border-1 bg-white text-dark border-secondary">
                      S
                    </span>
                    <span className="badge border border-1 bg-white text-dark border-secondary">
                      M
                    </span>
                    <span className="badge border border-1 bg-white text-dark border-secondary">
                      XL
                    </span>
                    <span className="badge border border-1 bg-white text-dark border-secondary">
                      XXL
                    </span>
                  </div>
                </div>
                {
                  alreadyAdded === false && <>
                   <div className="d-flex gap-10 flex-column mt-2 mb-3">
                  <h3 className="product-heading">Color :</h3>
                  <Color setColor ={setColor} colorData ={productState?.color} />
                </div>
                  </>
                }
                <div className="d-flex align-items-center gap-15 flex-row mt-2 mb-3">
                  {
                    alreadyAdded===false && <>
                    <h3 className="product-heading">Quantity : </h3>
                  <div className="">
                    <input
                      type="number"
                      name=""
                      min={1}
                      max={10}
                      className="form-control"
                      style={{ width: "70px" }}
                      id=""
                      onChange={(e)=>setquantity(e.target.value)}
                      value={quantity}
                    />
                  </div>
                    </>
                  }
                  <div className="d-flex align-items-center gap-30 ms-5">
                    <button
                      className="button border-0"
                      // data-bs-toggle="modal"
                      // data-bs-target="#staticBackdrop"
                      onClick={()=>{alreadyAdded ? navigate("/cart") : uploadCart()}}
                      type="button"
                    >
                      {alreadyAdded ? "Go to Cart": "Add to Cart"}
                    </button>
                    <button className="button signup">Buy It Now</button>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-15">
                  {/* <div>
                    <a href="">
                      <TbGitCompare className="fs-5 me-2" /> Add to Compare
                    </a>
                  </div> */}
                  {/* <div>
                    <a href="">
                      <AiOutlineHeart className="fs-5 me-2" /> Add to Wishlist
                    </a>
                  </div> */}
                </div>
                <div className="d-flex gap-10 flex-column  my-3">
                  <h3 className="product-heading">Shipping & Returns :</h3>
                  <p className="product-data">
                    Free shipping and returns available on all orders! <br /> 
                   
                  </p>
                </div>
                <div className="d-flex gap-10 align-items-center my-3">
        <h3 className="product-heading">Product Link:</h3>
        <a
        href="javascript:void(0)"
           className="p-2 mb-2 bg-secondary text-white"
          onClick={() => {
            copyToClipboard(
              window.location.href
            );
          }}
        >
          {isLinkCopied ? "Link Copied" : "Copy Product Link"}
        </a>
      </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Container class1="description-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h4 class="text-light">Description</h4>
            <div className="bg-white p-3">
              <p>
                {/* {productState?.description} */}
                <Markup content={productState?.description} />
              </p>
            </div>
          </div>
        </div>
      </Container>
      <Container class1="reviews-wrapper home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 id="review" class="text-light">Reviews</h3>
            <div className="review-inner-wrapper">
              <div className="review-head d-flex justify-content-between align-items-end">
                <div>
                  <h4 className="mb-2">Customer Reviews</h4>
                  <div className="d-flex align-items-center gap-10">
                    <ReactStars
                      count={5}
                      size={24}
                      value={Number(productState?.totalrating)}
                      edit={false}
                      activeColor="#ffd700"
                    />
                    <p className="mb-0">Based on {productState?.ratings?.length} Reviews</p>
                  </div>
                </div>
                {/* {orderedProduct && (
                  <div>
                    <a className="text-dark text-decoration-underline" href="">
                      Write a Review
                    </a>
                  </div>
                )} */}
              </div>
              <div className="review-form py-4">
                <h4>Write a Review</h4>
                {/* <form action="" onSubmit={addRatingToProduct} className="d-flex flex-column gap-15"> */}
                  <div>
                    <ReactStars
                      count={5}
                      size={24}
                      value={0}
                      edit={true}
                      activeColor="#ffd700"
                      onChange={(e)=>{
                        setStar(e);
                      }}
                    />
                  </div>
                  <div>
                    <textarea
                      name=""
                      id=""
                      className="w-100 form-control"
                      cols="30"
                      rows="4"
                      placeholder="Comments"
                      onChange={(e)=>{
                        setComment(e.target.value)
                      }}
                    ></textarea>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button className="button border-0" onClick={addRatingToProduct} type="button">Submit Review</button>
                  </div>
                {/* </form> */}
              </div>
              <div className="reviews mt-4">
                
                 {
                  productState && productState?.ratings?.map((item,index)=>{
                    return(
                      <div key={index} className="review">
                      <div  className="d-flex gap-10 align-items-center">
                      <h6 className="mb-0">Arpit</h6>
                      <ReactStars
                        count={5}
                        size={24}
                        value={item?.star}
                        edit={false}
                        activeColor="#ffd700"
                      />
                    </div>
                   
                   <p className="mt-3">
                   {item?.comment}
                 </p>
                 </div>
                    )
                  })
                 }
                  
                </div>
              
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default SingleProduct;